






















































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import PatientStatsTimelineChart from '@/components/patient-stats/graphs/PatientStatsTimelineChart.vue'
import NoteActionMenu from '@/components/sub-components/NoteActionMenu.vue'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as WatchListActionNames,
  GetterNames as WatchListGetterNames,
} from '@/store/modules/watch-list/keys'
import { WatchStatusTypes } from '@/store/modules/watch-list/types'
import { GetterNames } from '@/store/modules/patient/keys'
import { getPatientName } from '@/utils/patients'
import { timeout } from '@/utils/time'
import { ActionNames as PatientNoteActionNames } from '@/store/modules/patient-note/keys'
import { DetailedPatientActionNames, DetailedPatientGetterNames } from '@/store/modules/detailed-patient/keys'
import PeriodSelector from '@/components/sub-components/PeriodSelector.vue'
import { PATIENT_NOUN } from '@/constants/app-variables'

export default Vue.extend({
  components: {
    PatientStatsTimelineChart,
    NoteActionMenu,
    PeriodSelector,
  },
  inheritAttrs: false,
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientId: {
      type: String,
      required: true,
    },
    periodOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isUpdatingWatchList: false,
      isSendingNote: false,
      openDialog: false,
      noteText: '',
    }
  },
  computed: {
    ...mapGetters({
      watchLists: `${ModuleNames.watchList}/${WatchListGetterNames.watchLists}`,
    }),
    ...mapGetters(ModuleNames.patient, [GetterNames.patients]),
    ...mapGetters(ModuleNames.detailedPatient, [DetailedPatientGetterNames.patients]),
    currentWatchList() {
      return this.watchLists.find(watchList => watchList.patientId === this.patientId)
    },
    currentPatient() {
      return this[DetailedPatientGetterNames.patients].find(patient => patient.id === this.patientId)
    },
    watchIconColor() {
      if (!this.currentWatchList) {
        return this.$vuetify.theme.themes.light.mediumGrey
      } else {
        switch (this.currentWatchList.watchStatus) {
          case WatchStatusTypes.UNWATCH:
            return this.$vuetify.theme.themes.light.mediumGrey
          case WatchStatusTypes.MANUAL:
          case WatchStatusTypes.AUTO:
            return this.$vuetify.theme.themes.light.primary
          default:
            return this.$vuetify.theme.themes.light.primary
        }
      }
    },
    watchTooltipName() {
      if (!this.currentWatchList) {
        return ''
      }

      switch (this.currentWatchList.watchStatus) {
        case WatchStatusTypes.UNWATCH:
          return 'Watch'
        case WatchStatusTypes.MANUAL:
        case WatchStatusTypes.AUTO:
          return 'Unwatch'
        default:
          return ''
      }
    },
    patientName() {
      const patient = this[GetterNames.patients].find(_patient => _patient.id === this.patientId)
      return patient ? getPatientName(patient) : ''
    },
    patientPhoneNumber() {
      return this.currentPatient?.phone
    },
  },
  async mounted() {
    await this[WatchListActionNames.getWatchLists]()
    await this[DetailedPatientActionNames.getDetailedPatientById]({ patientId: this.patientId })
  },
  methods: {
    ...mapActions(ModuleNames.watchList, [
      WatchListActionNames.getWatchLists,
      WatchListActionNames.postWatchList,
      WatchListActionNames.patchWatchList,
    ]),
    ...mapActions(ModuleNames.patientNotes, [PatientNoteActionNames.addPatientNote]),
    ...mapActions(ModuleNames.detailedPatient, [DetailedPatientActionNames.getDetailedPatientById]),
    async onClickWatchIcon() {
      this.isUpdatingWatchList = true
      // post
      if (!this.currentWatchList) {
        await this[WatchListActionNames.postWatchList]({
          patientId: this.patientId,
          watchStatus: WatchStatusTypes.MANUAL,
        })
      } else {
        // patch
        switch (this.currentWatchList.watchStatus) {
          case WatchStatusTypes.UNWATCH:
            await this[WatchListActionNames.patchWatchList]({
              id: this.currentWatchList.id,
              watchStatus: WatchStatusTypes.MANUAL,
            })
            break
          case WatchStatusTypes.MANUAL:
          case WatchStatusTypes.AUTO:
            await this[WatchListActionNames.patchWatchList]({
              id: this.currentWatchList.id,
              watchStatus: WatchStatusTypes.UNWATCH,
            })
            break
          default:
            break
        }
      }

      await timeout(1000)
      await this[WatchListActionNames.getWatchLists]()
      this.isUpdatingWatchList = false
    },
    selectPeriod(option) {
      this.$emit('select:period-option', option)
    },
    openNoteDialog(): void {
      this.openDialog = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    closeNoteDialog(): void {
      this.openDialog = false
      this.noteText = ''
    },
    async sendNote(content): Promise<void> {
      if (this.isSendingNote) {
        return
      }
      this.closeNoteDialog()
      this.isSendingNote = true

      await this[PatientNoteActionNames.addPatientNote]({
        content,
        patientId: this.patientId,
      }).catch(error => {
        if (error && error.response && error.response.status == 403) {
          alert("Sorry, you're not authorized to add a note for this " + PATIENT_NOUN.toLowerCase() + '.')
        }
      })
      console.log('added patient note')

      this.isSendingNote = false
    },
  },
})
